import api, {config} from './api';

const service = {
  createConformanceReportUrl: async sysRowId => {
    const response = await api.get(`report/coc/generate/${sysRowId}`);
    if (response.hasErrors) {
      return undefined;
    }

    return `${config.baseURL}report/coc/${response.result}`;
  },
  createPartListReportUrl: async sysRowId => {
    const response = await api.get(`report/part-list/generate/${sysRowId}`);
    if (response.hasErrors) {
      return undefined;
    }

    return `${config.baseURL}report/part-list/${response.result}`;
  },
  createCurrentRevisionPartListReportUrl: async sysRowId => {
    const response = await api.get(`report/part-list-current-revision/generate/${sysRowId}`);
    if (response.hasErrors) {
      return undefined;
    }

    return `${config.baseURL}report/part-list-current-revision/${response.result}`;
  },
  createOtherRevisionsPartListReportUrl: async sysRowId => {
    const response = await api.get(`report/part-list-other-revisions/generate/${sysRowId}`);
    if (response.hasErrors) {
      return undefined;
    }

    return `${config.baseURL}report/part-list-other-revisions/${response.result}`;
  },
};

export default service;
